
import { computed, defineComponent } from 'vue'
import TickOutline from '@/components/vectors/TickOutline.vue'
import TicketDownloadButton from '@/components/TicketDownloadButton.vue'
import useSessions from '@/composables/useSessions'

export default defineComponent({
  components: {
    TickOutline,
    TicketDownloadButton
  },
  props: {
    title: {
      type: String,
      required: true
    },
    body: {
      type: String,
      required: true
    },
    downloadButtonText: {
      type: String,
      required: true
    },
    bookingButton: {
      type: Boolean,
      required: true
    },
    // Checkout still holds a live basket, which is what the ticket download is
    // named by. The booking itself is named by the reference the API issued.
    basketId: {
      type: String,
      required: true
    },
    bookingRef: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const { isLoggedIn } = useSessions()

    const viewBookingRoute = computed(() =>
      isLoggedIn.value
        ? { name: 'MyBookingInfo', params: { id: props.bookingRef } }
        : { name: 'SearchTickets' }
    )

    // Minting a reference is allowed to fail so that it can never turn a paid
    // order into an error. Offering no link beats one that resolves to nothing.
    const bookingLinkReady = computed(() => !isLoggedIn.value || !!props.bookingRef)

    return {
      bookingLinkReady,
      viewBookingRoute
    }
  }
})
